module.exports = __webpack_public_path__ + "img/ring_g_e_1_1@3x.54106b92.png";